import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";

@Pipe({
  name: 'employeeFormat',
})
export class EmployeeFormatPipe implements PipeTransform {
  constructor(private translate: TranslateService) {
  }

  transform(value: {
    lastname: string;
    firstname: string;
    rank?: { name: string } | string;
  }, long: boolean = false, isCurrentEmployee: boolean = false): string {
    const rankName = typeof value.rank === 'string' ? value.rank : value.rank?.name;
    let intermediateRepresentation = `${value.lastname} ${value.firstname}${long ? ` (${rankName})` : ''}`;
    if (isCurrentEmployee) {
      intermediateRepresentation;
    }

    return intermediateRepresentation;
  }
}
